export default {
  computed: {
    getUrl () {
      let fragment = `${window.location.protocol}//${window.location.host}`
      if (window.drupalSettings && window.drupalSettings.path.currentLanguage !== 'en') {
        fragment += `/${window.drupalSettings.path.currentLanguage}`
      }
      // fragment = 'http://gln.gerdau.localhost:8000'
      return fragment
    },
    langDefault() {
      return this.languages.find(item => item.isDefault === true)
    },
    getLangCurrent() {
      const { drupalSettings } = window 
      return drupalSettings ? drupalSettings.path.currentLanguage : this.languageCurrent.id.toLowerCase()
    }
  },
  methods: {
    returnPinSvg(color = '#FF0000') {
      return {
        path: "m 43.999999,65.98238 c 0,0.006 0.01176,0.0176 0.01176,0.0176 0,0 10.300202,-15.81481 10.300202,-21.01194 0,-7.64873 -5.220651,-10.9763 -10.311961,-10.98806 -5.091311,0.0118 -10.311961,3.33937 -10.311961,10.9881 0,5.19713 10.306081,21.01194 10.306081,21.01194 0,0 0.0059,-0.0176 0.0059,-0.0176 z m -3.56862,-21.42936 c 0,-1.97538 1.599118,-3.5745 3.574499,-3.5745 1.975382,0 3.5745,1.59912 3.5745,3.5745 0,1.97539 -1.604997,3.5745 -3.580379,3.5745 -1.969502,0 -3.56862,-1.59911 -3.56862,-3.5745 z",
        fillColor: color,
        fillOpacity: 1,
        anchor: new window.google.maps.Point(44,66),
        strokeWeight: 0,
        scale: 1
      }
    },
    returnValue(v) {
      if (v === null) return ''
      return v
    },
    processBounds(map, items = []) {
      let bounds = new window.google.maps.LatLngBounds()

      for (let child of this.processMarkerList(items)) {
        bounds.extend(child.geo)
      }
      map.fitBounds(bounds)
    },
    returnLatLng(coords = {lat: 0, lon: 0}) {
      if (!coords) return null
      return {
        lat: parseFloat(coords.lat),
        lng: parseFloat(coords.lon)
      }
    },
    processMarker(item) {
      if (item.geo) {
        let marker = {
          ...item,
        }
        marker.geo = this.returnLatLng(item.geo)
        return marker
      }
      return null
    },
    processMarkerList(list = []) {
      let markers = []

      // duplica os markers para cada categoria
      for (let index = 0; index < list.length; index++) {
        const item = list[index];
        
        if (item.categories && Array.isArray(item.categories)) {
          item.categories.map(c => {
            markers.push({ ...item, category: c })
          })
        } else {
          markers.push({ ...item })
        }
      }
      return markers.map(item => this.processMarker(item)).filter(item => item != null)
    },
    langToEnum(lang = {}) {
      return lang.argument.toUpperCase()
      // return 'PT_BR'
    },
    focusOnMap(data, refMap) {
      refMap.$mapPromise.then(map => {
        const bounds = new window.google.maps.LatLngBounds()
        let markerClosests = null
        let zoom = 8
        if (data.results[0].types.includes('administrative_area_level_1')) { // eh um estado, aparentemente
          bounds.extend(data.results[0].geometry.bounds.northeast)
          bounds.extend(data.results[0].geometry.bounds.southwest)
          // map.fitBounds(bounds)
          // const insideMarkers = this.filteredMarkers.filter(m => map.getBounds().contains(m.geo))
          
          // this.filteredMarkers.map(m => {
          //   if (map.getBounds().contains(m.geo)) {
          //     bounds.extend(m.geo)
          //   }
          // })
          // markerClosests = this.findClosestN(map, data.results[0], insideMarkers)
          zoom = 5
        } else {
          markerClosests = this.findClosestN(map, data.results[0])
          bounds.extend(markerClosests[0].geo)
        }
        map.fitBounds(bounds)
        map.setZoom(zoom)
        map.panToBounds(bounds)
      })
    },
    sortByDist(a, b) {
      return (a.distance - b.distance)
    },
    findClosestN(map, location, markers = this.filteredMarkers) {
      const closest = [];
      function getPos(geo) {
        return {
          lat: () => parseFloat(geo.lat),
          lng: () => parseFloat(geo.lng)
        }
      }
      for (var i = 0; i < markers.length; i++) {
        markers[i].distance = window.google.maps.geometry.spherical.computeDistanceBetween(getPos(location.geometry.location), getPos(markers[i].geo))
        closest.push(markers[i])
      }
      closest.sort(this.sortByDist)
      return closest
    }
  }
}
